import React from 'react';

export async function updateDocumentOnly(
	firebase,
	salesAgentPointer,
	clientKeyValue,
	projectCode,
	subjectState,
	subjectDetails
) {
	console.log('parameters', [
		firebase,
		salesAgentPointer,
		clientKeyValue,
		projectCode,
		subjectState,
		subjectDetails,
	]);
	var clientDocumentRef = await firebase
		.database()
		.ref(
			'/kavtek_clients/' +
				projectCode +
				'/salesAgents/' +
				salesAgentPointer +
				'/myClients/' +
				clientKeyValue +
				'/documentInformation/document'
		);

	clientDocumentRef.update({
		[subjectState]: subjectDetails,
	});
}
